import { services, serviceOrder } from '../data/services';

interface ServiceNavProps {
  currentSlug: string;
  onNavigate: (slug: string) => void;
}

export function ServiceNav({ currentSlug, onNavigate }: ServiceNavProps) {
  return (
    <section className="py-12 bg-gray-50 border-y border-border">
      <div className="container mx-auto px-4">
        <h3 className="mb-6 text-center">Explore Our Other Services</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto justify-items-center">
          {serviceOrder.map((slug) => {
            const service = services[slug];
            if (slug === currentSlug) return null;

            return (
              <button
                key={slug}
                onClick={() => onNavigate(slug)}
                className="p-4 bg-white border-2 border-border rounded-lg hover:border-primary hover:shadow-md transition-all text-left"
              >
                <p className="text-sm font-medium">{service.h1}</p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
